/*
 * getMapPoints module is in charge of returning a fromFetch observable to the calling control.
 * This observable represents a promise build around fetch javascript API. The result
 * of this promise holds an array of markers to paint in the map, so by returning the control
 * to the calling module, we will achieve to see those retrieved markers on screen as a
 * result of the observable promise returned.
 */

import { fromFetch } from 'rxjs/fetch';
import { mapGetCommunitiesPoints, mapGetHomesPoints } from 'constants/routes';

/**
 * Parses the fetch response into JSON.
 * Throws on non-2xx responses so the observable errors.
 *
 * NOTE:
 * - Consumers are responsible for handling errors (e.g. catchError, retry).
 */
const parseJsonResponse = (response) => {
  if (!response.ok) {
    throw new Error(`HTTP ${response.status}`);
  }

  return response.json();
};

const createRequest = (payload) => ({
  method: 'POST',
  body: JSON.stringify({
    searchCommand: {
      ...payload,
    },
  }),
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
  selector: parseJsonResponse,
});

/**
 * Generic map points fetcher.
 *
 * @param {string} url
 * @param {object} payload
 * @returns {Observable<any>}
 */
const getMapPoints$ = (url, payload) =>
  fromFetch(url, createRequest(payload));

export const getCommunityMapPoints$ = (payload) =>
  getMapPoints$(mapGetCommunitiesPoints, payload);

export const getHomeMapPoints$ = (payload) =>
  getMapPoints$(mapGetHomesPoints, payload);